import React, { useContext } from 'react';
import type {
  Maybe,
  Price,
  Product,
  ProductProperties,
  Shipping,
} from 'src/types';

type Offers = {
  filteredOffers: ExtendedPrice[];
};

export interface ExtendedPrice extends Price {
  unfilteredShippings?: Array<Shipping>;
}

export const EmptyProduct = {
  id: 0,
  media: { count: 0 },
  name: '',
  classicFullPath: '',
  pathName: '',
  priceSummary: {},
  userReviewSummary: {},
  coreProperties: {},
};

interface IProductContextValue {
  product: Product & Maybe<{ coreProperties: ProductProperties }>;
  offers: Offers;
  allOffers: Price[];
  allOffersWithActiveAdditives: Price[];
  priceInfoArticles?: Array<{
    pathName: string;
  }>;
}

const initialContextValue: IProductContextValue = {
  product: EmptyProduct,
  offers: { filteredOffers: [] },
  allOffers: [],
  allOffersWithActiveAdditives: [],
  priceInfoArticles: undefined,
};

export const ProductContext =
  React.createContext<IProductContextValue>(initialContextValue);

export const useProductContext = () => useContext(ProductContext);
